import {Pipe, PipeTransform} from '@angular/core';
import * as Nzh from 'nzh';

const cn = Nzh.cn;

@Pipe({
    name: 'convertNumber'
})
export class ConvertNumberPipe implements PipeTransform {

    /**
     * è½¬æ¢æ°å­ä¸ºä¸­æ
     * @param value
     * @param upper è½¬å°åè¿æ¯å¤§åï¼é»è®¤å°å
     */
    transform(value: any, upper?: boolean): any {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        if (upper) {
            return cn.encodeB(value);
        }
        return cn.encodeS(value);
    }

}
